import React from 'react'
import 'antd/dist/antd.css'

import { ComponentWrapperWithAITracking } from 'analytics/AppInsights'
import '../../VdgPatients.scss'
import { CheckCircleFilled, InfoCircleFilled, MinusCircleFilled } from '@ant-design/icons'

export enum colorDef {
  red = 'red',
  orange = 'orange',
  grey = 'grey',
}

interface Props {
  color: colorDef
  className: string
}

const VdgTestButton = (props: Props) => {
  const { color, className } = props

  let ret

  if (color == colorDef.red)
    ret = <CheckCircleFilled className={'dashboardRed' + ' ' + (className ? className : '')} />
  else if (color == colorDef.orange)
    ret = <InfoCircleFilled className={'dashboardOrange' + ' ' + (className ? className : '')} />
  else if (color == colorDef.grey)
    ret = <MinusCircleFilled className={'dashboardGrey' + ' ' + (className ? className : '')} />

  return <>{ret}</>
}

export default ComponentWrapperWithAITracking(VdgTestButton, 'VdgTestButton')
